// extracted by mini-css-extract-plugin
module.exports = {"block":"PostsList_block__upi97","posts":"PostsList_posts__Yffr5"};